<div class="spinner-parent">
<div class="spinner-border spinner">
</div>
</div>
